import { LoadableLazy } from '@confluence/loadable';
export { PageLabelsAutomationDiscovery } from '../src/PageLabelsAutomationDiscovery.tsx';
export const LazyPageLabelsAutomationDiscovery = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageLabelsAutomationDiscovery" */ '../src/PageLabelsAutomationDiscovery.tsx'
			)
		).PageLabelsAutomationDiscovery,
});
